import React from "react";
import { FaInstagram, FaYoutube, FaTwitter, FaLinkedin } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="/" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="social-icon" />
        </a>
        
        
      </div>
    </footer>
  );
};

export default Footer;
